import type { TeamT } from 'types'

export const getTenantLabel = (team: TeamT) => team?.tenant?.name || team?.owner?.name || ''
